// src/config.js
const config = {
  TEST_WEATHER_ICON_BLEND: true,   // toggle this on/off
  BLEND_RATIO: 0.3,                // how much time-of-day tint to apply
};

export default config;
